import { render, staticRenderFns } from "./CustomEvaluationForm.vue?vue&type=template&id=10560f83&scoped=true"
import script from "./CustomEvaluationForm.vue?vue&type=script&lang=js"
export * from "./CustomEvaluationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10560f83",
  null
  
)

export default component.exports